import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { FoodLogService } from './../../../data/repository/plan-repository/food-log.service';
import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/data/repository/profile-repository/profile.service';
import { DateHelper } from 'src/app/utils/date-helper';
import { ChartInputModel } from 'src/app/core/model/input/chart-input-model';

@Component({
  selector: 'app-diet-detail',
  templateUrl: './diet-detail.component.html',
  styleUrls: ['./diet-detail.component.scss'],
})
export class DietDetailComponent implements OnInit {
  page = 0;
  segment = 0;
  average = 0;
  startDate: Date;
  endDate: Date;
  barChartInput: ChartInputModel;

  title: string;

  showLoading = false;

  constructor(
    private profileService: ProfileService,
    private dateHelper: DateHelper,
    private foodLogService: FoodLogService,
    private snackBarService: SnackBarService
  ) {
    this.prepare();
  }

  ngOnInit() {}

  back() {
    this.profileService.goBack();
  }

  previousDays() {
    this.page--;
    this.prepare();
  }

  nextDays() {
    this.page++;
    this.prepare();
  }

  async prepare() {
    this.showLoading = true;
    const period = this.segment === 2 ? 120 : this.segment === 1 ? 28 : 4;
    this.startDate = new Date(
      new Date().setDate(new Date().getDate() + period * this.page)
    );
    this.endDate = new Date(
      new Date().setDate(
        new Date().getDate() + (period * this.page - period + 1)
      )
    );
    const startDateString =
      this.segment !== 2
        ? this.dateHelper.getYearAndMonthAndDayPersian(this.startDate)
        : this.dateHelper.getYearAndMonthPersian(this.startDate);
    const endDateString =
      this.segment !== 2
        ? this.dateHelper.getYearAndMonthAndDayPersian(this.endDate)
        : this.dateHelper.getYearAndMonthPersian(this.endDate);
    this.title = endDateString + ' - ' + startDateString;
    this.calculateCalorieInputLabels();
  }

  calculateCalorieInputLabels() {
    const labels = ['', '', '', ''];
    const period = this.segment === 2 ? 120 : this.segment === 1 ? 28 : 4;
    for (let i = 0; i < 4; i++) {
      const date = new Date(
        new Date().setDate(
          new Date().getDate() + (period * this.page - (i * period) / 4)
        )
      );
      if (this.segment === 0 && this.dateHelper.isSameDay(date, new Date())) {
        labels[i] = 'امروز';
      } else if (
        this.segment === 0 &&
        this.dateHelper.isSameDay(
          date,
          new Date(new Date().setDate(new Date().getDate() - 1))
        )
      ) {
        labels[i] = 'دیروز';
      } else if (this.segment === 2) {
        labels[i] = this.dateHelper.getPersianMonthName(date);
      } else {
        labels[i] = this.dateHelper.getMonthAndDayPersian(date);
      }
    }
    const data = [0, 0, 0, 0];
    this.barChartInput = new ChartInputModel(labels, data);
    this.prepareCalorieInputAmounts(labels);
  }

  async prepareCalorieInputAmounts(labels: string[]) {
    let startDate = new Date(this.startDate);
    startDate = new Date(startDate.setHours(23, 59, 59, 0));
    let endDate = new Date(this.endDate);
    endDate = new Date(endDate.setHours(0, 0, 0, 0));
    const period = this.segment === 2 ? 120 : this.segment === 1 ? 28 : 4;
    const periodString =
      this.segment === 2 ? 'month' : this.segment === 1 ? 'week' : 'day';
    this.average = 0;

    const foodlogChartResponse = await this.foodLogService.getFoodLogChart(
      endDate.getTime(),
      startDate.getTime(),
      periodString
    );
    if (foodlogChartResponse.isSuccess()) {
      const foodLogs = foodlogChartResponse.getData().getFoodLogChart();
      let counter = 0;
      const data = [0, 0, 0, 0];
      foodLogs.forEach((foodLog, index) => {
        data[3 - index] = foodLog.amount;
        if (foodLog.amount !== 0) {
          counter++;
        }
        this.average += foodLog.amount;
      });
      this.average = counter !== 0 ? Math.ceil(this.average / counter) : 0;
      this.barChartInput = new ChartInputModel(labels, data);
      this.showLoading = false;
    } else {
      this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      this.showLoading = false;
    }
  }

  segmentSelected(segment: number) {
    if (this.segment !== segment) {
      this.page = 0;
      this.segment = segment;
      this.prepare();
      document.getElementById('segment0').style.color = '#000000';
      document.getElementById('segment1').style.color = '#000000';
      document.getElementById('segment2').style.color = '#000000';
      document.getElementById('selected-segment').style.right =
        this.segment === 2
          ? 'calc( 66% - 2px )'
          : this.segment === 1
          ? 'calc( 34% - 2px )'
          : '2px';
      setTimeout(() => {
        document.getElementById('segment' + segment).style.color = '#0073ff';
      }, 100);
    }
  }
}
